<template>
  <div class="w-100">
    <main-hero />
    <div class="row">
      <div class="col">
        <register-form />
        <register-section-leads />
        <register-section-why-us />
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import store from '@/store';
import RegisterForm from '@/components/form/Register';
import MainHero from "@/components/section/MainHero"
import RegisterSectionLeads from "@/components/section/RegisterSectionLeads"
import RegisterSectionWhyUs from "@/components/section/RegisterSectionWhyUs"
import AppFooter from "@/components/footer/AppFooter"

export default {
  name: "Register",
  components: {RegisterForm, MainHero, RegisterSectionLeads, RegisterSectionWhyUs, AppFooter},
  beforeRouteEnter: function (to, from, next) {
    if (store.state.USER_STATE === true) {
      next({name:'dashboard'});
    } else {
      next();
    }
  },
}
</script>

<style scoped>

</style>
